import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const Form = styled('form')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
}));
